module.exports = __webpack_public_path__ + "img/r2c1.54272372.jpg";